const maskString = (str, maskChar = '*') => {
    return str.replace(/./g, () => maskChar);
};
/**
 * PII field transformers map
 * Note: Add new transformers here to mask PII fields
 */
const PIIFieldTransformers = Object.freeze({
    email: (email, data) => {
        const userId = data.userId || data.anonymousId || maskString(email.split('@')[0] || '');
        const domain = email.split('@')[1];
        return `${userId}@${domain}`;
    },
    firstName: (name, _data) => {
        return maskString(name);
    },
    lastName: (name, _data) => {
        return maskString(name);
    },
    name: (name, _data) => {
        return maskString(name);
    },
    phone: (phone, _data) => {
        return maskString(phone);
    },
    address: (address, _data) => {
        return maskString(address);
    }
});
/**
 * Transformation function to mask PII fields before sending to Cvent Analytics and Attendee Activities
 */
export default function maskPII(data) {
    return Object.entries(PIIFieldTransformers).reduce((acc, [key, transformer]) => {
        if (data[key]) {
            const piiFieldValue = data[key];
            // We only want to transform strings
            if (typeof piiFieldValue === 'string') {
                return {
                    ...acc,
                    [key]: transformer(piiFieldValue, data)
                };
            }
        }
        return acc;
    }, data);
}
//# sourceMappingURL=maskPII.js.map